//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      title: "الأسئلة الشائعة",
      description:
        "ماهي الخدمات المشمولة في الباقات؟ تشمل الباقات جميع الميزات والخدمات اللازمة لإطلاق متجرك الإلكتروني بداية من مرحلة الإعداد وحتى الربط مع مزودي الخدمات بأسعار حصرية وتفعيل الدفع الالكتروني بدون أي رسوم تأسيسية أو شهرية وحتى التسويق عن طريق نظام التسويق بالعمولة ونقاط المكافئات و قسائم التخفيض والعديد من الأدوات التسويقية الأخرى.",

      faqs: [
        {
          title: "هل أحتاج إضافة المنتجات والأقسام من جديد في التطبيق؟",
          content:
            "لا، لا يلزمك ذلك، فالتطبيق يرتبط بالمتجر مباشرة.",
        },
        {
          title: "هل يتضمن التطبيق أي تحديثات أو مزايا جديدة؟",
          content:
            "نعم، ستتم إضافة ميزات وخصائص جديدة بانتظام، وسيتم تحديث التطبيق تلقائياً عند إضافة أي خاصية أو ميزة جديدة",
        },
        {
          title: "كم يستغرق وقت تجهيز التطبيق؟",
          content:
            "يتراوح وقت تجهيز التطبيق بين 2 إلى 7 أيام عمل بعد إدخال بيانات التطبيق من قِبل العميل، ولكن يجب ملاحظة أن ذلك لا يشمل إنشاء حساب الشركة الخاص بالتاجر على منصة أبل وتفعيله، والتي تستغرق عادةً ما بين أسبوعين إلى شهر.",
        },
        {
          title: "هل يمكن تعديل تصميم التطبيق فيما بعد؟ وهل يتطلب ذلك دفع رسوم إضافية؟",
          content: "نعم، يمكن تعديل تصميم التطبيق فيما بعد من خلال لوحة التحكم الخاصة بمتجرك، وذلك بالدخول إلى تبويب تصميم التطبيق وإجراء التعديلات اللازمة، دون الحاجة لدفع أي رسوم إضافية.",
        },],
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale", // open graph type
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type", // open graph type
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title", // open graph title
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description", // open graph description
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url", // open graph url
          property: "og:url",
          content: "https://tajadad.app/faqs",
        },
        {
          hid: "og:site_name", // open graph site_name
          property: "og:site_name",
          content: "متجرة",
        },
        {
          hid: "og:updated_time", // open graph updated_time
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image", // open graph image
          property: "og:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
        {
          hid: "apple-mobile-web-app-title", // open graph mobile web app title
          name: "apple-mobile-web-app-title",
          content: this.title,
        },

        // open graph twitter
        { name: "twitter:site", content: "@Tajadad" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://tajadad.app/faqs",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://tajadad.app/faqs",
        },
      ],
    };
  },
  jsonld() {
    const items = this.faqs.map((item) => ({
      '@type': 'Question',
      "name": item.title,
      "acceptedAnswer": { "@type": "Answer", "text": item.content },
    }));
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "FAQPage",
          "mainEntity": items
        }
      ]
    }
  }
};
